// extracted by mini-css-extract-plugin
export default {"container":"ServerError_container__vE+HL","item":"ServerError_item__VBOKs"};